<template>
  <div id="app">
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  mounted() {
    window.addEventListener("load", this.hideURLbar, false);
  },
  beforeDestroy() {
    window.removeEventListener("load", this.hideURLbar, false);
  },
  methods: {
    hideURLbar() {
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 0);
    },
  },
};
</script>
<style>
body {
  font-family: "Poppins", sans-serif;
  margin: 0;
  padding: 0;
}
</style>
